module.exports = __webpack_public_path__ + "static/img/Alceon.93fae3d3.png";